import { render, staticRenderFns } from "./CalendarListItemSharingShareItem.vue?vue&type=template&id=12e99a9e&"
import script from "./CalendarListItemSharingShareItem.vue?vue&type=script&lang=js&"
export * from "./CalendarListItemSharingShareItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e99a9e')) {
      api.createRecord('12e99a9e', component.options)
    } else {
      api.reload('12e99a9e', component.options)
    }
    module.hot.accept("./CalendarListItemSharingShareItem.vue?vue&type=template&id=12e99a9e&", function () {
      api.rerender('12e99a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/CalendarListItemSharingShareItem.vue"
export default component.exports